/* eslint-disable security/detect-object-injection */
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import './CommercialPage.messages';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import metadata from './CommercialPage.metadata.json5';
import ProductandcoveragesselectionComponent from "../../components/CyberLiabilityCommercial/Productandcoveragesselection/ProductandcoveragesselectionComponent"
import BusinessComponent from "../../components/CyberLiabilityCommercial/Business/BusinessComponent"
import OperationsServicesComponent from "../../components/CyberLiabilityCommercial/OperationsServices/OperationsServicesComponent";
import TechnologyComponent from "../../components/CyberLiabilityCommercial/Technology/TechnologyComponent";

function CommercialPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const pathToUpdate = 'lobData.cybLiaLine.coverables.commercialCoverable'
    const {
        onValidate,
        initialValidation
    } = useValidation('CommercialPage');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [isValidationRequired, setIsValidationRequired] = useState(true);

    const onNext = useCallback(async () => {
        if(_.get(submissionVM, 'lobData.cybLiaLine.coverables.commercialCoverable.operationsAndServices.value.operationInternalClaffics.length') === 0 ) {
            setShowErrorMessage(true)
            
            return false
        }

        setShowErrorMessage(false)

        const productCode = _.get(submissionVM.value, 'baseData.productCode');
        const lobLineName = productCode ? lineName[productCode] : '';
        const response = await updateSubmission(lobLineName, 'CommercialPage', submissionVM);

        submissionVM.value = response;

        return submissionVM;
    }, [lineName, submissionVM, updateSubmission]);

    const onSave = useCallback(async () => {
        const subVMCopy = _.clone(submissionVM);
        const productCode = _.get(subVMCopy.value, 'baseData.productCode');

        validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.cybLiaLine?.coverables?.commercialCoverable?.value, ' ');

        const lobLineName = productCode ? lineName[productCode] : '';
        await updateSubmission(lobLineName, 'CommercialPage', subVMCopy);

        return submissionVM;
    }, [submissionVM]);


    const overrideProps = {
        ProductandcoveragesselectionComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathToUpdate}.productAndCoverageSelection`
        },
        BusinessComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathToUpdate}.business`,
            isValidationRequired
        },
        OperationsServicesComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathToUpdate}.operationsAndServices`
        },
        TechnologyComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathToUpdate}.techAssessment`,
            isValidationRequired
        },
        atleastOneCatNotification: {
            visible: showErrorMessage
        }

    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            ProductandcoveragesselectionComponent,
            BusinessComponent,
            OperationsServicesComponent,
            TechnologyComponent
        }
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !submissionVM.lobData.cybLiaLine.coverables.commercialCoverable.aspects.subtreeValid

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            onNext={onNext}
            onSave={onSave}
            onPrevious={() => setIsValidationRequired(false)}
        >
            <div>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    resolveValue={readValue}
                />
            </div>
        </WizardPage>
    );
}

CommercialPage.propTypes = wizardProps;
export default withViewModelService(CommercialPage);
